import { toOverallIndianCurrency } from "../../../MethodMaster/JSXComponentMothod";
import "../DashboardUnique.css";

export default function GrantSummaryCards({ amount, labhartiVillage }) {
  return (
    <div className={"govdash-summaryGrid"}>
      <div className={`${"govdash-summaryCard"} ${"govdash-amountCard"}`}>
        <div className={"govdash-cardContent"}>
          <i className="fas fa-house-user"></i>
          <div>
            <p className={"govdash-cardLabel"}>Total Labharthi Village</p>
            <span className={"govdash-cardValue"}>{labhartiVillage.toLocaleString()}</span>
          </div>
        </div>
        <div className={"govdash-cardBg"}></div>
      </div>
      <div className={`${"govdash-summaryCard"} ${"govdash-labhartiCard"}`}>
        <div className={"govdash-cardContent"}>
          <i className="fas fa-money-bill-wave"></i>
          <div>
            <p className={"govdash-cardLabel"}>Total Amount Disbursed</p>
            {/* <span className={'govdash-cardValue'}>₹{amount.toLocaleString()}</span> */}
            <span className={"govdash-cardValue"}>{toOverallIndianCurrency(parseFloat(amount))?.formatted}</span>
            <span className={"govdash-wordValue"}>({toOverallIndianCurrency(amount)?.answer.words})</span>
          </div>
        </div>
        <div className={"govdash-cardBg"}></div>
      </div>
    </div>
  );
}
